<template>
    <div>
    <v-row justify="center">
      <v-col  cols="12" xs="8" md="6" lg="6" xl="6"
      v-for="(item, i) in products"
      :key="i">
      <v-hover
        v-slot="{ hover }"
        close-delay="200"
      >
        <v-card
        height="100%"
        :elevation="hover ? 12 : 3"
          :class="{ 'on-hover': hover }"
        :href="item.href">
          <router-link :to="item.href">
            <v-img
            :src="item.src"
            height="200px"
            >
            </v-img>
         </router-link>
          <router-link :to="item.href" class="blue-grey--text">
            <v-card-title>
              {{ item.title }}
          </v-card-title>
          <v-card-text id="description">
            {{ item.description }}
          </v-card-text>
          </router-link>
        </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      products: [
        {
          title: 'e-Learningシステム',
          src: require('../../assets/Products/elearning.png'),
          height: '250',
          width: '332',
          href: '/Products/Elearning',
          description: '手間のかからないビデオ作成、コンテンツの全文検索、コンテンツの保護が特徴です。またゼロから開発を行っていますので、低コストでカスタマイズ可能です。'
        },
        {
          title: '全文検索システム',
          src: require('../../assets/Products/search.png'),
          height: '248',
          width: '350',
          href: '/Products/Search',
          description: '弊社の全文検索システムは、e-Learningシステム、技術資料や論文等、様々なシステムに組み込み可能です。'
        },
        {
          title: '歯科予約システム',
          src: require('../../assets/Products/reserveDental.png'),
          height: '250',
          width: '329',
          href: '/Products/reserveDental',
          description: '患者は、スマホ、携帯、PCからご予約を行えます。医院に合わせて細かにカスタマイズ可能です。 '
        },
        {
          title: '診療予約システム',
          src: require('../../assets/Products/reserveMedical.png'),
          height: '250',
          width: '268',
          href: '/Products/reserveMedical',
          description: '患者は、スマホ、携帯、PCから当日順番待ち予約と、ワクチン等の時間予約が行えます。医院に合わせて細かにカスタマイズ可能です。ご試用可能ですのでお問合せください。'
        },
        {
          title: '学術集会向けオンライン演題登録/査読システム',
          src: require('../../assets/Products/registration.png'),
          height: '250',
          width: '180',
          href: '/Products/registration',
          description: 'オンライン演題登録システム、査読システムともに学術集会の方針に合わせてカスタマイズを行います。'
        },
        {
          title: '学術集会向け事前参加登録システム',
          src: require('../../assets/Products/participation.png'),
          height: '250',
          width: '180',
          href: '/Products/participation',
          description: '学術集会向け事前参加登録システムをご用意しています。同伴者の同時申し込み、懇親会等のオプションに応じて登録可能です。'
        }
      ]
    }
  }
}
</script>
